/*
  Commented.by.KWShin.2023.07.26.
  이 파일의 설정은 /components/grid/SingleLineDataTable에서 해석되어 화면에 표시된다.
  1. value: API를 통해 서버에서 읽어온 데이터 필드 명
  2. text: value를 보여줄 컬럼의 컬럼명
  3. align: Grid의 컬럼에 표시될 때 데이터의 정렬 방법
  4. display: 디폴트로 화면에 보여질 것인 지 여부
  5. converter
     - 인자로 String이 전달되면 이는 함수 명
     - 인자로 String Array가 전달되면, 0번째는 함수명, 1번째는 함수 인자
     - 함수는 $options에 사전에 등록된 함수이어야 함
 */
/*
  Added.by.KWShin.2023.07.26.
  이 파일의 추가된 설정은 /components/grid/SingleLineDataTableNeo에서만 해석되어 화면에 표시된다.
  1. type
     - 이 설정이 없으면 기존의 SingleLineDataTable과 동일
     - 'icon': String으로 전달. value의 데이터는 { icon, style, msgCode } 이어야 함. icon 속성은 icon의 종류, style은 icon의 CSS style, msgcd는 tooltip text를 위한 메시지 코드.
     - 'enumtype': Array로 전달. 0번째는 'enumtype',  1번째는 화면에 표시할 필드(enumtype {}의 속성)의 이름. value의 데이터는 Java enumtype의 Json 표현인 {} 이어야 함.
     . 이 설정은 SingleLingDataTableNeo에 prop로 전달되는 itemEllipsis 옵션과 동시에 사용할 수 없음. v-tooltip 기능이 겹쳐서 동시 지원 불가.
 */
export default {
  G_DB_EXCL_LOCK: {
    fields: [
      // { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      // { value: 'svrYmdhms', text: 'Collected time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 0 },
      // { value: 'objName', text: 'Object name', align: 'start', display: 1 },
      // { value: 'holderSid', text: 'SID (Holder)', align: 'end', converter: 'comma', display: 1 },
      // { value: 'hHostName', text: 'Application Server', align: 'start', display: 1 },
      // { value: 'hodlerPid', text: 'PID', align: 'end', converter: 'comma', display: 1 },
      // { value: 'waiterSid', text: 'SID', align: 'end', converter: 'comma', display: 1 },
      // { value: 'wHostname', text: 'Name of Current Application Server', align: 'start', display: 1 },
      // { value: 'waiterPid', text: 'PID of an R/3 WP (DB Session)', align: 'end', converter: 'comma', display: 1 },
      // { value: 'heldSince', text: 'Number of Seconds that a DB has been locked', align: 'end', converter: 'comma', display: 1 },
      // { value: 'waitssince', text: 'Number of Seconds waiting for a DB Lock', align: 'end', converter: 'comma', display: 1 },
      // { value: 'lockLevel', text: 'DB Lock step', align: 'end', converter: 'comma', display: 1 },
      // { value: 'addInfo', text: 'Container for Additional Database-Dependent Inform', align: 'start', display: 1 },
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      { value: 'objName', text: 'Object name', align: 'start', display: 1 },
      { value: 'wHostname', text: 'Host name', align: 'start', display: 1 },
      { value: 'sapYmdhms', text: 'Date & time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'heldSince', text: 'Held since (sec)', align: 'end', converter: 'comma', display: 1 },
      { value: 'waitssince', text: 'Wait since (sec)', align: 'end', converter: 'comma', display: 1 },
      { value: 'lockLevel', text: 'Lock level', align: 'end', converter: 'comma', display: 1 },
      { value: 'holderSid', text: 'Holder SID', align: 'end', converter: 'comma', display: 1 },
      { value: 'hodlerPid', text: 'Holder PID', align: 'end', converter: 'comma', display: 1 },
      { value: 'waiterSid', text: 'Waiter SID', align: 'end', converter: 'comma', display: 1 },
      { value: 'waiterPid', text: 'Waiter PID', align: 'end', converter: 'comma', display: 1 },
    ],
  },
  G_DB_HANA_LOCK: {
    fields: [
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      { value: 'acquiredTime', text: 'Lock time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'lockTime', text: 'Elapsed time', align: 'end', converter: 'comma', display: 1 },
      { value: 'lockType', text: 'Lock type', align: 'center', display: 1 },
      { value: 'objectId', text: 'Object ID', align: 'start', display: 1 },
      { value: 'schemaName', text: 'Schema name', align: 'start', display: 1 },
      { value: 'objectName', text: 'Object name', align: 'start', display: 1 },
      { value: 'objectType', text: 'Object type', align: 'center', display: 1 },
      { value: 'lockMode', text: 'Lock mode', align: 'center', display: 1 },
      { value: 'statementId', text: 'Statement ID', align: 'center', display: 1 },
      { value: 'userName', text: 'SQL User name', align: 'start', display: 1 },
      { value: 'applicationName', text: 'Application', align: 'start', display: 1 },
      { value: 'applicationUserName', text: 'App. user name', align: 'start', display: 1 },
      { value: 'applicationSource', text: 'App. source', align: 'start', display: 1 },
    ],
  },
  // BEGIN::Added.by.KWShin.2024.09.23.
  G_DB_ORCL_TABL: {
    fields: [
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      { value: 'sapYmdhms', text: 'Date & Time', align: 'start', display: 1 },
      { value: 'ts', text: 'Name', align: 'start', display: 1 },
      { value: 'initExt', text: 'Initial extent', align: 'end', converter: 'comma', display: 1 },
      { value: 'nextExt', text: 'Next extent', align: 'end', converter: 'comma', display: 1 },
      { value: 'minExt', text: 'Minimum extent', align: 'end', converter: 'comma', display: 1 },
      { value: 'maxExt', text: 'Maximum extent', align: 'end', converter: 'comma', display: 1 },
      { value: 'pctIncr	', text: 'Percentage increase', align: 'end', converter: ['concat', ' %'], display: 1 },
      { value: 'status', text: 'Status', align: 'start', display: 1 },
      { value: 'tsize', text: 'Size', align: 'end', converter: 'comma', display: 1 },
      { value: 'tfree', text: 'Free space', align: 'end', converter: 'comma', display: 1 },
      { value: 'tpctused', text: 'Used rate', align: 'end', converter: ['concat', ' %'], display: 1 },
      // { value: 'textents', text: 'Total number of extents', align: 'end', converter: 'comma', display: 0 },
      // { value: 'tsegments', text: 'Number of segments', align: 'end', converter: 'comma', display: 0 },
      // { value: 'tsau', text: 'Total maximum autoextensible size (kbyte)', align: 'end', converter: 'kilobytes', display: 0 },
      // { value: 'tsaupct', text: '% of maximum autoextensible size used', align: 'end', converter: ['concat', ' %'], display: 0 },
    ],
  },
  G_DB_ORCL_SPACE: {
    fields: [
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      { value: 'svrYmdhms', text: 'Date & Time', align: 'start', display: 1 },
      // { value: 'dbsys', text: 'Central Database System', align: 'start', display: 0 },
      // { value: 'sysid', text: 'Name of the SAP System', align: 'start', display: 0 },
      // { value: 'tsno', text: 'Number of Tablespaces', align: 'end', converter: 'comma', display: 0 },
      { value: 'tssi', text: 'Total Size', align: 'end', converter: 'kilobytes', display: 1 },
      { value: 'tsfr', text: 'Free Space', align: 'end', converter: 'kilobytes', display: 1 },
      { value: 'tsfrp', text: 'Free Rate', align: 'end', converter: ['concat', ' %'], display: 1 },
      // { value: 'tsmf', text: 'Minimum freespace per tablespace (kbyte)', align: 'end', converter: 'kilobytes', display: 0 },
      // { value: 'tsus', text: 'Number of tablespaces with freespace problems', align: 'end', display: 0 },
      { value: 'tano', text: 'Tables: Total number', align: 'end', converter: 'comma', display: 1 },
      { value: 'tino', text: 'Indexes: Total Number', align: 'end', converter: 'comma', display: 1 },
      // { value: 'ta1e', text: 'Tables with more than one extent', align: 'end', converter: 'comma', display: 0 },
      // { value: 'ti1e', text: 'Indexes with more than one extent', align: 'end', converter: 'comma', display: 0 },
      { value: 'tasi', text: 'Tables: Total size', align: 'end', converter: 'kilobytes', display: 1 },
      { value: 'tisi', text: 'Indexes: Total size', align: 'end', converter: 'kilobytes', display: 1 },
      // { value: 'taci', text: 'Tables: Missing in database', align: 'end', converter: 'comma', display: 0 },
      // { value: 'tici', text: 'Indexes: Missing in database', align: 'end', converter: 'comma', display: 0 },
      // { value: 'taoi', text: 'Tables: Missing in ABAP DDIC', align: 'end', converter: 'comma', display: 0 },
      // { value: 'tioi', text: 'Indexes: Missing in ABAP DDIC', align: 'end', converter: 'comma', display: 0 },
      // { value: 'tavi', text: 'Tables with freespace problems', align: 'end', converter: 'comma', display: 0 },
      // { value: 'tivi', text: 'Indexes with freespace problems', align: 'end', converter: 'comma', display: 0 },
      { value: 'tsau', text: 'Total maximum autoextensible size', align: 'end', converter: 'kilobytes', display: 1 },
    ],
  },
  G_DB_HANA_MEM: {
    fields: [
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      { value: 'svrYmdhms', text: 'Date & Time', align: 'start', display: 1 },
      { value: 'host', text: 'Host name', align: 'start', display: 1 },
      { value: 'physMemTotal', text: 'Total memory', align: 'end', converter: 'megabytes', display: 1 },
      { value: 'physMemUsed', text: 'Used memory', align: 'end', converter: 'megabytes', display: 1 },
      { value: 'physMemFree', text: 'Free memory', align: 'end', converter: 'megabytes', display: 1 },
      { value: 'allocationLimit', text: 'Allocation limit', align: 'start', display: 1 },
      { value: 'hanaMemUsed', text: 'HANA database total used memory', align: 'end', converter: 'megabytes', display: 0 },
      // { value: 'codeSize', text: 'Code size', align: 'end', converter: 'megabytes', display: 0 },
      // { value: 'stackSize', text: 'Stack size', align: 'end', converter: 'megabytes', display: 0 },
    ],
  },
  G_DB_HANA_SPACE: {
    fields: [
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      { value: 'svrYmdhms', text: 'Date & Time', align: 'start', display: 1 },
      { value: 'host', text: 'Host name', align: 'start', display: 1 },
      { value: 'port', text: 'Internal port', align: 'start', display: 1 },
      { value: 'serviceName', text: 'Service name', align: 'start', display: 1 },
      { value: 'volumeId', text: 'Volume ID', align: 'start', display: 1 },
      { value: 'subpath', text: 'Sub path', align: 'start', display: 1 },
      { value: 'livecacheStore', text: 'Livecache', align: 'start', display: 1 },
      { value: 'fileType', text: 'Type of file', align: 'start', display: 1 },
      { value: 'fileName', text: 'File name', align: 'start', display: 1 },
      { value: 'totalSize', text: 'Total size', align: 'end', converter: 'bytes', display: 1 },
      { value: 'usedSize', text: 'Used size', align: 'end', converter: 'bytes', display: 1 },
    ],
  },
  // FINISH::Added.by.KWShin.2024.09.23.
  G_ABAP_ENQ_LOCK: {
    fields: [
      // { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      // { value: 'svrYmdhms', text: 'Collected time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 0 },
      // { value: 'gname', text: 'Table name', align: 'start', display: 1 },
      // { value: 'garg', text: 'Argument String', align: 'start', display: 1 },
      // { value: 'gmode', text: 'Lock Mode', align: 'start', display: 1 },
      // { value: 'gusr', text: 'Lock Owner, ID of logical Unit of Work (LUW)', align: 'start', display: 1 },
      // { value: 'gusrvb', text: 'Lock Owner, ID of logical Unit of Work (LUW) /Upda', align: 'start', display: 1 },
      // { value: 'guse', text: 'Cumulative counter for Lock Entry /Dialog', align: 'end', converter: 'comma', display: 1 },
      // { value: 'gusevb', text: 'Cumulative counter for lock entry /Update Task', align: 'end', converter: 'comma', display: 1 },
      // { value: 'gobj', text: 'Name of Lock Object in the Lock Entry', align: 'start', display: 1 },
      // { value: 'gclient', text: 'Client', align: 'start', display: 1 },
      // { value: 'guname', text: 'User name', align: 'start', display: 1 },
      // { value: 'gtarg', text: 'Argument String', align: 'start', display: 1 },
      // { value: 'gtcode', text: 'Transaction Code', align: 'start', display: 1 },
      // { value: 'gbcktype', text: 'Backup Flag', align: 'start', display: 1 },
      // { value: 'gthost', text: 'Host name in the Lock Owner ID', align: 'start', display: 1 },
      // { value: 'gtwp', text: 'Work Process Number', align: 'end', converter: 'comma', display: 1 },
      // { value: 'gtsysnr', text: 'SAP System Number ', align: 'end', converter: 'comma', display: 1 },
      // { value: 'gtusec', text: 'Time Share in Lock Owner ID', align: 'end', converter: 'comma', display: 1 },
      // { value: 'gtmark', text: 'Selection Indicator', align: 'start', display: 1 },
      // { value: 'gusetxt', text: 'Cumulative counter for Lock Entry /Dialog', align: 'end', converter: 'comma', display: 1 },
      // { value: 'gusevbt', text: 'Cumulative counter for Lock Entry /Update Task', align: 'end', converter: 'comma', display: 1 },
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      { value: 'gclient', text: 'Client', align: 'start', display: 1 },
      { value: 'guname', text: 'User', align: 'start', display: 1 },
      { value: 'sapYmdhms', text: 'Date & time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'gmode', text: 'Lock Mode', align: 'start', display: 1 },
      { value: 'gname', text: 'Table name', align: 'start', display: 1 },
      { value: 'gtcode', text: 'T-Code', align: 'start', display: 1 },
      { value: 'gtwp', text: 'WP No.', align: 'end', converter: 'comma', display: 1 },
    ],
  },
  G_ABAP_UPD_REC: {
    fields: [
      // { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      // { value: 'svrYmdhms', text: 'Collected time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 0 },
      // { value: 'bgnYmdhms', text: 'Start date time', align: 'start', display: 0 },
      // { value: 'endYmdhms', text: 'End date time', align: 'start', display: 1 },
      // { value: 'vbkey', text: 'Key for Update and Enqueue/Dequeue', align: 'start', display: 1 },
      // { value: 'vbmandt', text: 'Client for update request', align: 'start', display: 1 },
      // { value: 'vbusr', text: 'User name in update request', align: 'start', display: 1 },
      // { value: 'vbaccnt', text: 'Update accounting', align: 'start', display: 1 },
      // { value: 'vbreport', text: 'Program that generated the update request', align: 'start', display: 1 },
      // { value: 'vbtcode', text: 'Transaction which has created the update request', align: 'start', display: 1 },
      // { value: 'vbenqkey', text: 'Enqueue Key', align: 'start', display: 1 },
      // { value: 'vbrc', text: 'Update return code', align: 'end', converter: 'comma', display: 1 },
      // { value: 'vbname', text: 'Name of the Executing Update Server', align: 'start', display: 1 },
      // { value: 'vbcontext', text: 'Update context', align: 'start', display: 1 },
      // { value: 'vbstate', text: 'Global status of an update request', align: 'start', display: 1 },
      // { value: 'vbcliinfo', text: 'Byte Value', align: 'start', display: 1 },
      // { value: 'vblang', text: 'Language', align: 'start', display: 1 },
      // { value: 'vbdatfm', text: 'Single-Character Indicator', align: 'start', display: 1 },
      // { value: 'vbdcpfm', text: 'Single-Character Indicator', align: 'start', display: 1 },
      // { value: 'vbdate', text: 'Date and time of update record (sort)', align: 'start', display: 1 },
      // { value: 'vbtransid', text: 'SAP Statistics: Transaction ID', align: 'start', display: 1 },
      // { value: 'vbetransid', text: 'SAP Statistics: Transaction ID', align: 'start', display: 1 },
      // { value: 'vbetransln', text: 'Length of External Transaction ID', align: 'end', converter: 'comma', display: 1 },
      // { value: 'vbcliname', text: 'Name of the Executing Update Server', align: 'start', display: 1 },
      // { value: 'vbzonlo', text: 'Name of Local time Zone', align: 'start', display: 1 },
      // { value: 'vbtimoff', text: 'Offset Local to System time', align: 'end', converter: 'comma', display: 1 },
      // { value: 'statusText', text: 'Status Text', align: 'start', display: 1 },
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      { value: 'vbmandt', text: 'Client', align: 'start', display: 1 },
      { value: 'vbusr', text: 'User', align: 'start', display: 1 },
      { value: 'vbdate', text: 'Date & time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'vbtcode', text: 'T-Code', align: 'start', display: 1 },
      { value: 'vbreport', text: 'Program', align: 'start', display: 1 },
      { value: 'statusText', text: 'Status', align: 'start', display: 1 },
    ],
  },
  G_ABAP_TRFC_QIN: {
    fields: [
      // { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      // { value: 'svrYmdhms', text: 'Collected time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 0 },
      // { value: 'mandt', text: 'Client ID of Current user', align: 'start', display: 1 },
      // { value: 'arfcipid', text: 'Host ID', align: 'start', display: 1 },
      // { value: 'arfcpid', text: 'Process ID', align: 'start', display: 1 },
      // { value: 'arfctime', text: 'Time Stamp', align: 'start', display: 1 },
      // { value: 'arfctidcnt', text: 'Transaction ID (LUW -> COMMIT WORK)', align: 'start', display: 1 },
      // { value: 'qname', text: 'Name of tRFC queue', align: 'start', display: 1 },
      // { value: 'qcount', text: 'Counter for serialized tRFC', align: 'end', converter: 'comma', display: 1 },
      // { value: 'hpqname', text: 'Name of tRFC queue', align: 'start', display: 1 },
      // { value: 'dest', text: 'Logical Destination (Specified in Function Call)', align: 'start', display: 1 },
      // { value: 'nosend', text: 'CHAR01 data element for SYST', align: 'start', display: 1 },
      // { value: 'qstate', text: 'Transactional tRFC queue status', align: 'start', display: 1 },
      // { value: 'qlockcnt', text: 'Counter for serialized tRFC', align: 'end', converter: 'comma', display: 1 },
      // { value: 'qrfcuser', text: 'User name', align: 'start', display: 1 },
      // { value: 'qrfcfnam', text: 'Name of Function Module', align: 'start', display: 1 },
      // { value: 'qrfcYmdhms', text: 'qRFC time of Application Server', align: 'start', display: 1 },
      // { value: 'orgtid', text: 'Character field of length 24', align: 'start', display: 1 },
      // { value: 'qluwcnt', text: 'Counter within a transaction (LUW)', align: 'start', display: 1 },
      // { value: 'batchpla', text: 'Internal ABAP System Field', align: 'start', display: 1 },
      // { value: 'retryYmdhms', text: 'Retry time of Application Server', align: 'start', display: 1 },
      // { value: 'retrynr', text: 'No. of attempts', align: 'start', display: 1 },
      // { value: 'qmailed', text: 'CHAR01 data element for SYST', align: 'start', display: 1 },
      // { value: 'errmess', text: 'Message Text', align: 'start', display: 1 },
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      { value: 'mandt', text: 'Client', align: 'start', display: 1 },
      { value: 'qrfcuser', text: 'User', align: 'start', display: 1 },
      { value: 'qrfcYmdhms', text: 'Date & time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'qrfcfnam', text: 'Function module', align: 'start', display: 1 },
      { value: 'dest', text: 'Destination', align: 'start', display: 1 },
      { value: 'qstate', text: 'Queue status', align: 'start', display: 1 },
      { value: 'errmess', text: 'Message text', align: 'start', display: 1 },
      { value: 'retryYmdhms', text: 'Retry time', align: 'start', display: 1 },
      { value: 'retrynr', text: 'No. of attempts', align: 'start', display: 1 },
    ],
  },
  G_ABAP_TRFC_QOUT: {
    fields: [
      // { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      // { value: 'svrYmdhms', text: 'Collected time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 0 },
      // { value: 'mandt', text: 'Client ID of Current user', align: 'start', display: 1 },
      // { value: 'arfcipid', text: 'Host ID', align: 'start', display: 1 },
      // { value: 'arfcpid', text: 'Process ID', align: 'start', display: 1 },
      // { value: 'arfctime', text: 'Time Stamp', align: 'start', display: 1 },
      // { value: 'arfctidcnt', text: 'Transaction ID (LUW -> COMMIT WORK)', align: 'start', display: 1 },
      // { value: 'qname', text: 'Name of tRFC queue', align: 'start', display: 1 },
      // { value: 'dest', text: 'Logical Destination (Specified in Function Call)', align: 'start', display: 1 },
      // { value: 'qcount', text: 'Counter for serialized tRFC', align: 'end', converter: 'comma', display: 1 },
      // { value: 'hpqname', text: 'Name of tRFC queue', align: 'start', display: 1 },
      // { value: 'nosend', text: 'CHAR01 data element for SYST', align: 'start', display: 1 },
      // { value: 'qstate', text: 'Transactional tRFC queue status', align: 'start', display: 1 },
      // { value: 'qlockcnt', text: 'Counter for serialized tRFC', align: 'start', display: 1 },
      // { value: 'qrfcuser', text: 'User name', align: 'start', display: 1 },
      // { value: 'qrfcfnam', text: 'Name of Function Module', align: 'start', display: 1 },
      // { value: 'qrfcYmdhms', text: 'qRFC time of Application Server', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      // { value: 'qluwcnt', text: 'Counter within a transaction (LUW)', align: 'start', display: 1 },
      // { value: 'qmailed', text: 'CHAR01 data element for SYST', align: 'start', display: 1 },
      // { value: 'errmess', text: 'Message Text', align: 'start', display: 1 },
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      { value: 'mandt', text: 'Client', align: 'start', display: 1 },
      { value: 'qrfcuser', text: 'User', align: 'start', display: 1 },
      { value: 'qrfcYmdhms', text: 'Data & time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'qrfcfnam', text: 'Function module', align: 'start', display: 1 },
      { value: 'qstate', text: 'Queue status', align: 'start', display: 1 },
      { value: 'errmess', text: 'Message Text', align: 'start', display: 1 },
      { value: 'dest', text: 'Destination', align: 'start', display: 1 },
    ],
  },
  G_ABAP_OS_CPU: {
    fields: [
      // { value: 'svrYmdhms', text: 'Collected time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 0 },
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      // { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      { value: 'instShortAlias', text: 'Instance ID', align: 'start', display: 1 },
      { value: 'lastcollwrt', text: 'Date & time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'usrTotal', text: 'User total', align: 'end', converter: ['concat', ' %'], display: 1 },
      { value: 'sysTotal', text: 'System total', align: 'end', converter: ['concat', ' %'], display: 1 },
      { value: 'idleTotal', text: 'Idle total', align: 'end', converter: ['concat', ' %'], display: 1 },
      { value: 'waitTrue', text: 'IO Wait', align: 'end', converter: ['concat', ' %'], display: 1 },
      { value: 'syscSec', text: 'System Calls', align: 'end', converter: 'comma', display: 1 },
      { value: 'intSec', text: 'Interrupts', align: 'end', converter: 'comma', display: 1 },
      { value: 'nbrCpu', text: 'CPU Number', align: 'end', converter: 'comma', display: 1 },
      { value: 'csSec', text: 'Context Switches', align: 'end', converter: 'comma', display: 1 },
    ],
  },
  G_ABAP_OS_MEM: {
    fields: [
      // { value: 'svrYmdhms', text: 'Collected time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 0 },
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      // { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      { value: 'instShortAlias', text: 'Instance ID', align: 'start', display: 1 },
      { value: 'lastcollwrt', text: 'Date & time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'physMem', text: 'Total memory', align: 'end', converter: 'kilobytes', display: 1 },
      { value: 'freeMem', text: 'Free memory', align: 'end', converter: 'kilobytes', display: 1 },
      { value: 'memUsedRate', text: 'Used rate (memory)', align: 'end', converter: 'kilobytes', display: 1 },
      { value: 'swapUsedRate', text: 'Used rate (swap)', align: 'end', converter: 'kilobytes', display: 1 },
      { value: 'inPgSec', text: 'Page in (sec)', align: 'end', converter: 'comma', display: 1 },
      { value: 'outPgSec', text: 'Page out (sec)', align: 'end', converter: 'comma', display: 1 },
      { value: 'inKbSec', text: 'Page in (KB/sec)', align: 'end', converter: 'kilobytes', display: 1 },
      { value: 'outKbSec', text: 'Page out (KB/sec)', align: 'end', converter: 'kilobytes', display: 1 },
      { value: 'swapConf', text: 'Swap config', align: 'end', converter: 'kilobytes', display: 1 },
      { value: 'swapFree', text: 'Swap free', align: 'end', converter: 'kilobytes', display: 1 },
      { value: 'swapSize', text: 'Swap size', align: 'end', converter: 'kilobytes', display: 1 },
      { value: 'swapMax', text: 'Swap Max', align: 'end', converter: 'kilobytes', display: 1 },
    ],
  },
  G_ABAP_OS_DISK: {
    fields: [
      // { value: 'svrYmdhms', text: 'Collected time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 0 },
      // { value: 'serialnr', text: 'Serial No', align: 'start', display: 1 },
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      // { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      { value: 'instShortAlias', text: 'Instance ID', align: 'start', display: 1 },
      { value: 'lastcollwrt', text: 'Date & time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'diskname', text: 'Disk name', align: 'start', display: 1 },
      { value: 'response', text: 'Response time', align: 'end', converter: 'mis2Msms', display: 1 },
      { value: 'util', text: 'Util', align: 'end', converter: ['concat', ' %'], display: 1 },
      { value: 'avgQueuel', text: 'Average queue length', align: 'end', converter: 'comma', display: 1 },
      { value: 'avgWait', text: 'Average Wait', align: 'end', converter: 'mis2Msms', display: 1 },
      { value: 'avgServic', text: 'Service time', align: 'end', converter: 'mis2Msms', display: 1 },
      { value: 'kbSec', text: 'Transfered', align: 'end', converter: 'kilobytes', display: 1 },
      { value: 'opSec', text: 'Operations', align: 'end', converter: 'comma', display: 1 },
    ],
  },
  G_ABAP_OS_NTWK: {
    fields: [
      // { value: 'svrYmdhms', text: 'Collected time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 0 },
      // { value: 'packets', text: 'Packets', align: 'end', converter: 'comma', display: 1 },
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      // { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      { value: 'instShortAlias', text: 'Instance ID', align: 'start', display: 1 },
      { value: 'lastcollwrt', text: 'Date & time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'lanname', text: 'LAN name', align: 'start', display: 1 },
      { value: 'inPackets', text: 'Packets in', align: 'end', converter: 'comma', display: 1 },
      { value: 'outPackets', text: 'Packets out', align: 'end', converter: 'comma', display: 1 },
      { value: 'inErrors', text: 'Errors in', align: 'end', converter: 'comma', display: 1 },
      { value: 'outErrors', text: 'Errors out', align: 'end', converter: 'comma', display: 1 },
      { value: 'collisions', text: 'Collisions', align: 'end', converter: 'comma', display: 1 },
    ],
  },
  // BEGIN::Added.by.2024.09.06.KWShin.
  // 묘하다... 왜 이게 여태 없었을까? 원래 없었나?
  G_ABAP_OS_FSYS: {
    fields: [
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      { value: 'instShortAlias', text: 'Instance ID', align: 'start', display: 1 },
      { value: 'lastcollwrt', text: 'Date & time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'fsysname', text: 'File system name', align: 'start', display: 1 },
      { value: 'capacity', text: 'Size', align: 'end', converter: ['concat', ' MB'], display: 1 },
      { value: 'free', text: 'Available', align: 'end', converter: ['concat', ' MB'], display: 1 },
      { value: 'used', text: 'Used', align: 'end', converter: ['concat', ' MB'], display: 1 },
      { value: 'usedRate', text: 'Used rate', align: 'end', converter: ['concat', ' %'], display: 1 },
    ],
  },
  // FINISH::Added.by.2024.09.06.KWShin.
  // G_ABAP_OS_TOP_PROC에서 G_ABAP_OS_PRCS로 변경.2022.07.18.KWShin.
  G_ABAP_OS_PRCS: {
    fields: [
      // { value: 'svrYmdhms', text: 'Collected time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 0 },
      // { value: 'privPages', text: 'Priv Pages', align: 'end', converter: 'comma', display: 1 },
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      // { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      { value: 'instShortAlias', text: 'Instance ID', align: 'start', display: 1 },
      { value: 'lastcollwrt', text: 'Date & time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'username', text: 'OS User', align: 'start', display: 1 },
      { value: 'command', text: 'Command', align: 'start', display: 1 },
      { value: 'cpuUtil', text: 'CPU Util', align: 'end', converter: ['concat', ' %'], display: 1 },
      { value: 'cpuTime', text: 'CPU Time', align: 'end', display: 1 },
      { value: 'resSize', text: 'MEM Size', align: 'end', converter: 'kilobytes', display: 1 },
      { value: 'procId', text: 'PID', align: 'start', display: 1 },
      { value: 'priority', text: 'Priority', align: 'end', converter: 'comma', display: 1 },
    ],
  },
  // BEGIN::Added.by.2022.07.18.KWShin.
  G_PCAP_OS_CPU: {
    fields: [
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      // { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      { value: 'instShortAlias', text: 'Instance ID', align: 'start', display: 1, cellColor: 'instColor' },
      { value: 'svrYmdhms', text: 'Date & time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'usrTotal', text: 'User total', align: 'end', converter: ['concat', ' %'], display: 1 },
      { value: 'sysTotal', text: 'System total', align: 'end', converter: ['concat', ' %'], display: 1 },
      { value: 'niceTotal', text: 'Nice total', align: 'end', converter: ['concat', ' %'], display: 1 },
      { value: 'idleTotal', text: 'Idle total', align: 'end', converter: ['concat', ' %'], display: 1 },
      { value: 'activeThreads', text: 'Active threads', align: 'end', converter: 'comma', display: 1 },
      { value: 'totalThreads', text: 'Total threads', align: 'end', converter: 'comma', display: 1 },
    ],
  },
  G_PCAP_OS_MEM: {
    fields: [
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      // { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      { value: 'instShortAlias', text: 'Instance ID', align: 'start', display: 1, cellColor: 'instColor' },
      { value: 'svrYmdhms', text: 'Date & time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'memTotal', text: 'Total memory', align: 'end', converter: 'kilobytes', display: 1 },
      { value: 'memFree', text: 'Free memory', align: 'end', converter: 'kilobytes', display: 1 },
      { value: 'memUsed', text: 'Used memory', align: 'end', converter: 'kilobytes', display: 1 },
      { value: 'memAvail', text: 'Available memory', align: 'end', converter: 'kilobytes', display: 1 },
      { value: 'shared', text: 'Shared', align: 'end', converter: 'bilobytes', display: 1 },
      { value: 'buffers', text: 'Buffers', align: 'end', converter: 'bilobytes', display: 1 },
      { value: 'cached', text: 'Cached', align: 'end', converter: 'kilobytes', display: 1 },
      { value: 'swapTotal', text: 'Total swap', align: 'end', converter: 'kilobytes', display: 1 },
      { value: 'swapFree', text: 'Free swap', align: 'end', converter: 'kilobytes', display: 1 },
      { value: 'swapUsed', text: 'Used swap', align: 'end', converter: 'kilobytes', display: 1 },
    ],
  },
  G_PCAP_OS_DISK: {
    fields: [
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      // { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      { value: 'instShortAlias', text: 'Instance ID', align: 'start', display: 1, cellColor: 'instColor' },
      { value: 'svrYmdhms', text: 'Date & time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'devName', text: 'Disk name', align: 'start', display: 1 },
      { value: 'kbSec', text: 'Transfered (KB/sec)', align: 'end', converter: 'kilobytes', display: 1 },
      { value: 'readKbs', text: 'Read (KB/sec)', align: 'end', converter: 'kilobytes', display: 1 },
      { value: 'writeKbs', text: 'Write (KB/sec)', align: 'end', converter: 'kilobytes', display: 1 },
      { value: 'readAwait', text: 'Read await', align: 'end', converter: 'comma', display: 1 },
      { value: 'writeAwait', text: 'Write await', align: 'end', converter: 'comma', display: 1 },
      { value: 'avgQueueLen', text: 'Average queue length', align: 'end', converter: 'comma', display: 1 },
    ],
  },
  G_PCAP_OS_NTWK: {
    fields: [
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      // { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      { value: 'instShortAlias', text: 'Instance ID', align: 'start', display: 1, cellColor: 'instColor' },
      { value: 'svrYmdhms', text: 'Date & time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'lanName', text: 'LAN name', align: 'start', display: 1 },
      { value: 'inPackets', text: 'Packets in', align: 'end', converter: 'comma', display: 1 },
      { value: 'outPackets', text: 'Packets out', align: 'end', converter: 'comma', display: 1 },
      { value: 'inKb', text: 'In (KB)', align: 'end', converter: 'kilobytes', display: 1 },
      { value: 'outKb', text: 'Out (KB)', align: 'end', converter: 'kilobytes', display: 1 },
      { value: 'inErrors', text: 'Errors in', align: 'end', converter: 'comma', display: 1 },
      { value: 'outErrors', text: 'Errors out', align: 'end', converter: 'comma', display: 1 },
      { value: 'collisions', text: 'Collisions', align: 'end', converter: 'comma', display: 1 },
    ],
  },
  // BEGIN::Added.by.2024.09.06.KWShin.
  // 묘하다... 왜 이게 여태 없었을까? 원래 없었나?
  G_PCAP_OS_FSYS: {
    fields: [
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      { value: 'instShortAlias', text: 'Instance ID', align: 'start', display: 1, cellColor: 'instColor' },
      { value: 'svrYmdhms', text: 'Date & time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'name', text: 'File system name', align: 'start', display: 1 },
      { value: 'size', text: 'Size', align: 'end', converter: ['concat', ' MB'], display: 1 },
      { value: 'avail', text: 'Available', align: 'end', converter: ['concat', ' MB'], display: 1 },
      { value: 'used', text: 'Used', align: 'end', converter: ['concat', ' MB'], display: 1 },
      { value: 'usedRate', text: 'Used rate', align: 'end', converter: ['concat', ' %'], display: 1 },
    ],
  },
  // FINISH::Added.by.2024.09.06.KWShin.
  G_PCAP_OS_PRCS: {
    fields: [
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      // { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      { value: 'instShortAlias', text: 'Instance ID', align: 'start', display: 1, cellColor: 'instColor' },
      { value: 'svrYmdhms', text: 'Date & time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'pid', text: 'PID', align: 'start', display: 1 },
      { value: 'ppid', text: 'PPID', align: 'start', display: 1 },
      { value: 'state', text: 'State', align: 'center', display: 1 },
      { value: 'cpuUtil', text: 'CPU Utilization', align: 'end', converter: ['concat', ' %'], display: 1 },
      { value: 'cpuTime', text: 'CPU Time (sec)', align: 'end', converter: 'comma', display: 1 },
      { value: 'resSize', text: 'Residence (KB)', align: 'end', converter: 'kilobytes', display: 1 },
      { value: 'priority', text: 'Priority', align: 'center', display: 1 },
      { value: 'nice', text: 'Nice', align: 'center', display: 1 },
      { value: 'numThreads', text: 'Threads', align: 'end', converter: 'comma', display: 1 },
      { value: 'username', text: 'OS User', align: 'start', display: 1 },
      { value: 'command', text: 'Command', align: 'start', display: 1 },
    ],
  },
  // FINISH::Added.by.2022.07.18.KWShin.
  G_ABAP_LOGON_GRP: {
    fields: [
      // { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      // { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      // { value: 'svrYmdhms', text: 'Collected time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 0 },
      // { value: 'classname', text: 'Group name', align: 'start', display: 1 },
      // { value: 'applserver', text: 'Instance name', align: 'start', display: 1 },
      // { value: 'grouptype', text: 'Group type', align: 'start', display: 1 },
      // { value: 'ipAddress', text: 'IP Address', align: 'start', display: 1 },
      // { value: 'respTime', text: 'Response time', align: 'end', converter: 'mis2Msms', display: 1 },
      // { value: 'users', text: 'Users', align: 'end', converter: 'comma', display: 1 },
      // { value: 'opMode', text: 'Multi-purpose logon', align: 'start', display: 1 },
      // { value: 'wpQuota', text: 'Maximum Work Processes', align: 'end', converter: 'comma', display: 1 },
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      { value: 'svrYmdhms', text: 'Date & time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'classname', text: 'Group name', align: 'start', display: 1 },
      { value: 'applserver', text: 'Instance name', align: 'start', display: 1 },
      { value: 'grouptype', text: 'Group type', align: 'start', display: 1 },
      { value: 'respTime', text: 'Response time', align: 'end', converter: 'mis2Msms', display: 1 },
      { value: 'users', text: 'Number of users', align: 'end', converter: 'comma', display: 1 },
      { value: 'wpQuota', text: 'Maximum WP', align: 'end', converter: 'comma', display: 1 },
    ],
  },
  G_ABAP_LOGON_USER: {
    fields: [
      // { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      // { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      // { value: 'svrYmdhms', text: 'Collected time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 0 },
      // { value: 'tid', text: 'Terminal ID', align: 'start', display: 1 },
      // { value: 'mandt', text: 'Client', align: 'start', display: 1 },
      // { value: 'bname', text: 'User name', align: 'start', display: 1 },
      // { value: 'tcode', text: 'Transaction Code', align: 'start', display: 1 },
      // { value: 'term', text: 'Terminal', align: 'start', display: 1 },
      // { value: 'zeit', text: 'Time of last activity', align: 'start', display: 1 },
      // { value: 'master', text: 'Security Context', align: 'start', display: 1 },
      // { value: 'trace', text: 'User trace', align: 'start', display: 1 },
      // { value: 'extmodi', text: 'Number of sessions', align: 'start', display: 1 },
      // { value: 'totalMemMb', text: 'Size of Allocated Memory', align: 'end', converter: 'megabytes', display: 1 },
      // { value: 'type', text: 'Type of logon', align: 'start', display: 1 },
      // { value: 'stat', text: 'Status of System logon', align: 'start', display: 1 },
      // { value: 'protocol', text: 'Logon Protocol of Plugin', align: 'start', display: 1 },
      // { value: 'guiversion', text: 'Version of SAPGUI', align: 'start', display: 1 },
      // { value: 'rfcType', text: 'Type of RFC logon', align: 'start', display: 1 },
      // { value: 'hostaddr', text: 'Host Address', align: 'start', display: 1 },
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      // { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      { value: 'instShortAlias', text: 'Instance ID', align: 'start', display: 1, cellColor: 'instColor' },
      { value: 'svrYmdhms', text: 'Date & time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'mandt', text: 'Client', align: 'start', display: 1 },
      { value: 'bname', text: 'User', align: 'start', display: 1 },
      { value: 'tcode', text: 'Transaction Code', align: 'start', display: 1 },
      { value: 'term', text: 'Terminal', align: 'start', display: 1 },
      { value: 'hostaddr', text: 'Host address', align: 'start', display: 1 },
      { value: 'type', text: 'Logon type', align: 'start', display: 1 },
      { value: 'extmodi', text: 'Number of sessions', align: 'start', display: 1 },
      { value: 'totalMemMb', text: 'Allocated memory (MB)', align: 'end', converter: 'megabytes', display: 1 },
    ],
  },
  G_ABAP_LOGON_DUP: {
    fields: [
      // { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      // { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      // { value: 'svrYmdhms', text: 'Collected time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 0 },
      // { value: 'mandt', text: 'Client', align: 'start', display: 1 },
      // { value: 'bname', text: 'User name', align: 'start', display: 1 },
      // { value: 'term', text: 'Terminal', align: 'start', display: 1 },
      // { value: 'extmodi', text: 'Sessions', align: 'start', display: 1 },
      // { value: 'totalMemMb', text: 'Allocated Memory', align: 'end', converter: 'megabytes', display: 1 },
      // { value: 'type', text: 'Type of logon', align: 'start', display: 1 },
      // { value: 'stat', text: 'Status', align: 'start', display: 1 },
      // { value: 'rfcType', text: 'Type of RFC logon', align: 'start', display: 1 },
      // { value: 'hostaddr', text: 'Host Address', align: 'start', display: 1 },
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      { value: 'svrYmdhms', text: 'Date & time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'mandt', text: 'Client', align: 'start', display: 1 },
      { value: 'bname', text: 'User', align: 'start', display: 1 },
      { value: 'term', text: 'Terminal', align: 'start', display: 1 },
      { value: 'hostaddr', text: 'Host Address', align: 'start', display: 1 },
      { value: 'extmodi', text: 'Number of sessions', align: 'start', display: 1 },
      { value: 'totalMemMb', text: 'Allocated memory (MB)', align: 'end', converter: 'megabytes', display: 1 },
    ],
  },
  G_ABAP_WORK_PROC_TYPE: {
    fields: [
      // { value: 'stime', text: 'SAP time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      // { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      { value: 'instShortAlias', text: 'Instance ID', align: 'start', display: 1, cellColor: 'instColor' },
      { value: 'ctime', text: 'Date & time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'wpType', text: 'Type', align: 'start', display: 1, cellColor: 'wpTypeColor' },
      { value: 'totalCount', text: 'Total', align: 'end', converter: 'comma', display: 1 },
      { value: 'waitingCount', text: 'Waiting', align: 'end', converter: 'comma', display: 1 },
      { value: 'runningCount', text: 'Running', align: 'end', converter: 'comma', display: 1 },
      { value: 'onHoldCount', text: 'On Hold', align: 'end', converter: 'comma', display: 1 },
    ],
  },
  G_ABAP_WORK_PROC: {
    fields: [
      // { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      // { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      // { value: 'svrYmdhms', text: 'Collected time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 0 },
      // { value: 'sapYmdhms', text: 'SAP time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 0 },
      // { value: 'wpNo', text: 'Work Process No', align: 'start', display: 1 },
      // { value: 'wpTyp', text: 'Type', align: 'start', display: 1 },
      // { value: 'wpPid', text: 'Process ID', align: 'start', display: 1 },
      // { value: 'wpStatus', text: 'Status', align: 'start', display: 1 },
      // { value: 'wpCpu', text: 'CPU', align: 'start', display: 1 },
      // { value: 'wpMem', text: 'Memory', align: 'end', converter: 'kilobytes', display: 1 },
      // { value: 'wpWaiting', text: 'Why Work Process is waiting', align: 'start', display: 1 },
      // { value: 'wpSem', text: 'Semaphore', align: 'start', display: 1 },
      // { value: 'wpRestart', text: 'Restart After Error', align: 'start', display: 1 },
      // { value: 'wpDumps', text: 'Restart work process after dump', align: 'start', display: 1 },
      // { value: 'wpEltime', text: 'Previous Runtime of Request (elapsed)', align: 'start', display: 1 },
      // { value: 'wpMandt', text: 'Client', align: 'start', display: 1 },
      // { value: 'wpBname', text: 'User Currently Served', align: 'start', display: 1 },
      // { value: 'wpReport', text: 'Report now running', align: 'start', display: 1 },
      // { value: 'wpAction', text: 'Current Activity', align: 'start', display: 1 },
      // { value: 'wpTable', text: 'DB Table Last accessed', align: 'start', display: 1 },
      // { value: 'wpServer', text: 'Server name', align: 'start', display: 1 },
      // { value: 'wpWaitinf', text: 'Additional Information about the Reason for waiting', align: 'start', display: 1 },
      // { value: 'wpWaittim', text: 'Time When waiting Started', align: 'start', display: 1 },
      // { value: 'wpSemstat', text: 'Internal Work Process type', align: 'start', display: 1 },
      // { value: 'wpIndex', text: 'Index of Work Process', align: 'start', display: 1 },
      // { value: 'wpCuaRep', text: 'Index of Work Process', align: 'start', display: 1 },
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      // { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      { value: 'instShortAlias', text: 'Instance ID', align: 'start', display: 1, cellColor: 'instColor' },
      { value: 'sapYmdhms', text: 'Date & time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      // BEGIN::Modified.by.KWShin.2024.11.19.
      // Workprocess 개수가 100개 이상이면 wpNo에 숫자 대신 **가 넘어오는 경우가 있어 wpIndex를 사용하는 것으로 수정.2024.11.19.KWShin.
      //{ value: 'wpNo', text: 'WP No', align: 'start', display: 1 },
      { value: 'wpIndex', text: 'WP No', align: 'start', display: 1 },
      // FINISH::Modified.by.KWShin.2024.11.19.
      { value: 'wpPid', text: 'WP PID', align: 'start', display: 1 },
      { value: 'wpTyp', text: 'Type', align: 'start', display: 1, cellColor: 'wpTypeColor' },
      { value: 'wpStatus', text: 'Status', align: 'start', display: 1 },
      { value: 'wpWaiting', text: 'Reason', align: 'start', display: 1 },
      { value: 'wpCpu', text: 'CPU', align: 'start', display: 1 },
      { value: 'wpMem', text: 'Memory', align: 'end', converter: 'kilobytes', display: 1 },
      { value: 'wpReport', text: 'Report', align: 'start', display: 1 },
      { value: 'wpMandt', text: 'Client', align: 'start', display: 1 },
      { value: 'wpBname', text: 'User', align: 'start', display: 1 },
      { value: 'wpAction', text: 'Action', align: 'start', display: 1 },
      { value: 'wpTable', text: 'Table', align: 'start', display: 1 },
    ],
  },
  G_ABAP_QUEUE: {
    fields: [
      // { value: 'svrYmdhms', text: 'Collected time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 0 },
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      // { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      { value: 'instShortAlias', text: 'Instance ID', align: 'start', display: 1, cellColor: 'instColor' },
      { value: 'svrYmdhms', text: 'Date & time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'reqType', text: 'WP Type', align: 'start', display: 1, converter: 'wpTypeQueue', cellColor: 'wpTypeColor' },
      { value: 'now', text: 'Count', align: 'end', converter: 'comma', display: 1 },
      { value: 'high', text: 'High', align: 'end', converter: 'comma', display: 1 },
      { value: 'max', text: 'Max', align: 'end', converter: 'comma', display: 1 },
      { value: 'writes', text: 'Write', align: 'end', converter: 'comma', display: 1 },
      { value: 'reads', text: 'Read', align: 'end', converter: 'comma', display: 1 },
    ],
  },
  G_ABAP_MEMORY: {
    fields: [
      // { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      // { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      // { value: 'svrYmdhms', text: 'Collected time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 0 },
      // { value: 'sapYmdhms', text: 'SAP time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 0 },
      // { value: 'areaName', text: 'Area name', align: 'start', display: 1 },
      // { value: 'areaWp', text: 'Work Process size', align: 'end', converter: 'comma', display: 1 },
      // { value: 'areaShm', text: 'Shared Memory size', align: 'end', converter: 'comma', display: 1 },
      // { value: 'areaSize', text: 'Total Area size', align: 'end', converter: 'comma', display: 1 },
      // { value: 'currUsed', text: 'Current size', align: 'end', converter: 'comma', display: 1 },
      // { value: 'maxUsed', text: 'Max used', align: 'end', converter: 'comma', display: 1 },
      // { value: 'fileSize', text: 'File size', align: 'end', converter: 'comma', display: 1 },
      // { value: 'quotaDia', text: 'Dialog Quota', align: 'end', converter: 'comma', display: 1 },
      // { value: 'quotaNdia', text: 'Non-dialog Quota', align: 'end', converter: 'comma', display: 1 },
      // { value: 'hitratio', text: 'Hit Ratio', align: 'end', converter: ['concat', ' %'], display: 1 },
      // { value: 'currUsedP', text: 'Current used rate', align: 'end', converter: ['concat', ' %'], display: 1 },
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      // { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      { value: 'instShortAlias', text: 'Instance ID', align: 'start', display: 1, cellColor: 'instColor' },
      { value: 'sapYmdhms', text: 'Date & time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'areaName', text: 'Area name', align: 'start', display: 1 },
      { value: 'currUsedP', text: 'Used rate', align: 'end', converter: ['concat', ' %'], display: 1 },
      { value: 'hitratio', text: 'Hit Ratio', align: 'end', converter: ['concat', ' %'], display: 1 },
      { value: 'areaSize', text: 'Total size', align: 'end', converter: 'comma', display: 1 },
      { value: 'currUsed', text: 'Current size', align: 'end', converter: 'comma', display: 1 },
      { value: 'maxUsed', text: 'Max used', align: 'end', converter: 'comma', display: 1 },
    ],
  },
  G_ABAP_BUFF: {
    fields: [
      // { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      // { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      // { value: 'svrYmdhms', text: 'Collected time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 0 },
      // { value: 'sapYmdhms', text: 'SAP time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 0 },
      // { value: 'allocSize', text: 'Size of Allicated Address Space', align: 'end', converter: 'comma', display: 1 },
      // { value: 'availSize', text: 'Storage Space Available', align: 'end', converter: 'comma', display: 1 },
      // { value: 'frameSize', text: 'Length of the Buffer Frames', align: 'end', converter: 'comma', display: 1 },
      // { value: 'maxObjects', text: 'Maximum Number of Objects', align: 'end', converter: 'comma', display: 1 },
      // { value: 'hashWidth', text: 'Width of Hashing Values used', align: 'end', converter: 'comma', display: 1 },
      // { value: 'cutValue', text: 'Cut Value', align: 'end', converter: 'comma', display: 1 },
      // { value: 'actObjects', text: 'Number of Active Objects', align: 'end', converter: 'comma', display: 1 },
      // { value: 'conObjects', text: 'Number of Known Objects', align: 'end', converter: 'comma', display: 1 },
      // { value: 'usedSpace', text: 'Storage Space used by Active Objects', align: 'end', converter: 'comma', display: 1 },
      // { value: 'maxFrmes', text: 'Maximum Number of Frames Available', align: 'end', converter: 'comma', display: 1 },
      // { value: 'allocFrms', text: 'Number of Frames used', align: 'end', converter: 'comma', display: 1 },
      // { value: 'request', text: 'Number of Object Requests to the Buffer', align: 'end', converter: 'comma', display: 1 },
      // { value: 'hit', text: 'Number of Successful Request', align: 'end', converter: 'comma', display: 1 },
      // { value: 'objNFnd', text: 'Number of Failed Request', align: 'end', converter: 'comma', display: 1 },
      // { value: 'insert', text: 'Number of Buffer Inserts', align: 'end', converter: 'comma', display: 1 },
      // { value: 'update', text: 'Number of Object Changes', align: 'end', converter: 'comma', display: 1 },
      // { value: 'reqDelete', text: 'Number of Delete Requests for an Object from the B', align: 'end', converter: 'comma', display: 1 },
      // { value: 'delete', text: 'Number of Invalidated Objects', align: 'end', converter: 'comma', display: 1 },
      // { value: 'freeObject', text: 'Number of Objects Released from the Buffer', align: 'end', converter: 'comma', display: 1 },
      // { value: 'dbAcces', text: 'Number of Database accesses', align: 'end', converter: 'comma', display: 1 },
      // { value: 'dbAccSvd', text: 'Number of Database accesses Saved', align: 'end', converter: 'comma', display: 1 },
      // { value: 'reorg', text: 'Number of Buffer Compact/Reorg', align: 'end', converter: 'comma', display: 1 },
      // { value: 'swap', text: 'Number of Objects Swapped', align: 'end', converter: 'comma', display: 1 },
      // { value: 'swapFrame', text: 'Number of Frames Swapped', align: 'end', converter: 'comma', display: 1 },
      // { value: 'search', text: 'Number of Search Operations', align: 'end', converter: 'comma', display: 1 },
      // { value: 'searchIns', text: 'Number of Search Operations during Roll-in', align: 'end', converter: 'comma', display: 1 },
      // { value: 'sumSize', text: 'Sum of the sizes of the Rolled-in Objects', align: 'end', converter: 'comma', display: 1 },
      // { value: 'sumSize2', text: 'Sum of sizes of Rolled-in Objects (Power of 2)', align: 'end', converter: 'comma', display: 1 },
      // { value: 'maxSize', text: 'Maximum Object size', align: 'end', converter: 'comma', display: 1 },
      // { value: 'minSize', text: 'Minimum Object size', align: 'end', converter: 'comma', display: 1 },
      // { value: 'refresh', text: 'Counter for the Number of Buffer Refreshes', align: 'end', converter: 'comma', display: 1 },
      // { value: 'sizeUnit', text: 'Unit used if', align: 'end', converter: 'comma', display: 1 },
      // { value: 'reserve', text: 'Reserve', align: 'end', converter: 'comma', display: 1 },
      // { value: 'alloc', text: 'Storage Class', align: 'start', display: 1 },
      // { value: 'smode', text: 'Search Procedure', align: 'start', display: 1 },
      // { value: 'upTime', text: 'Start time for Statistics', align: 'start', display: 1 },
      // { value: 'lastRefr', text: 'Time of Last Buffer Refresh', align: 'start', display: 1 },
      // { value: 'name', text: 'Area name', align: 'start', display: 1 },
      // { value: 'hitratio', text: 'Hit Ratio', align: 'end', converter: ['concat', ' %'], display: 1 },
      // { value: 'dbQuality', text: 'Quality of the SAP Buffer (DB Interface)', align: 'end', converter: ['concat', ' %'], display: 1 },
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      // { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      { value: 'instShortAlias', text: 'Instance ID', align: 'start', display: 1, cellColor: 'instColor' },
      { value: 'sapYmdhms', text: 'Date & time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'name', text: 'Area name', align: 'start', display: 1 },
      { value: 'allocSize', text: 'Allicated size', align: 'end', converter: 'comma', display: 1 },
      { value: 'request', text: 'Requests', align: 'end', converter: 'comma', display: 1 },
      { value: 'hitratio', text: 'Hit ratio', align: 'end', converter: ['concat', ' %'], display: 1 },
      { value: 'dbAcces', text: 'DB Accesses', align: 'end', converter: 'comma', display: 1 },
      { value: 'dbQuality', text: 'DB Quality', align: 'end', converter: ['concat', ' %'], display: 1 },
      { value: 'usedSpace', text: 'Used size', align: 'end', converter: 'comma', display: 1 },
    ],
  },
  G_ABAP_DUMP: {
    fields: [
      // { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      { value: 'svrYmdhms', text: 'Collected time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 0 },
      { value: 'sapYmdhms', text: 'SAP time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'dumpId', text: 'Dump ID', align: 'start', display: 1 },
      { value: 'pgmNm', text: 'Program name', align: 'start', display: 1 },
      { value: 'incPgmNm', text: 'Include Program name', align: 'start', display: 1 },
      { value: 'pgmLine', text: 'Program Line', align: 'start', display: 1 },
      { value: 'transid', text: 'Transaction GUID', align: 'start', display: 1 },
      { value: 'ahost', text: 'Name of Current Application Server', align: 'start', display: 1 },
      { value: 'uname', text: 'User name', align: 'start', display: 1 },
      { value: 'mandt', text: 'Client ID of Current user', align: 'start', display: 1 },
      { value: 'modno', text: 'Index of Work Process', align: 'start', display: 1 },
      { value: 'seqno', text: 'Sequence No', align: 'start', display: 1 },
      { value: 'xhold', text: 'X-hold', align: 'start', display: 1 },
      { value: 'flist', text: 'Field List', align: 'start', display: 0 },
      { value: 'flist02', text: 'Field List 02', align: 'start', display: 0 },
      { value: 'flist03', text: 'Field List 03', align: 'start', display: 0 },
      { value: 'flist04', text: 'Field List 04', align: 'start', display: 0 },
      { value: 'flist05', text: 'Field List 05', align: 'start', display: 0 },
      { value: 'flist06', text: 'Field List 06', align: 'start', display: 0 },
      { value: 'flist07', text: 'Field List 07', align: 'start', display: 0 },
      { value: 'flist08', text: 'Field List 08', align: 'start', display: 0 },
    ],
  },
  // BEGIN::Added.by.2023.06.21.KWShin.
  G_ABAP_APP_LOG: {
    fields: [
      { value: 'lampIcon', text: '', align: 'center', display: 1, type: 'icon' },
      { value: 'sapYmdhms', text: 'SAP Time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'aluser', text: 'User', align: 'start', display: 1 },
      { value: 'last_msgnr', text: 'Number', align: 'end', display: 1 },
      { value: 'extnumber', text: 'External ID', align: 'start', display: 1 },
      { value: 'objtxt', text: 'Object text', align: 'start', display: 1 },
      { value: 'subobjtxt', text: 'Sub-object text', align: 'start', display: 1 },
      { value: 'altcode', text: 'T-Code', align: 'start', display: 1 },
      { value: 'alprog', text: 'Program', align: 'start', display: 1 },
      { value: 'almode', text: 'Mode', align: 'start', display: 1, type: ['enumtype', 'text'] },
      { value: 'lognumber', text: 'Log number', align: 'start', display: 1 },
      { value: 'svrYmdhms', text: 'Collect Time', align: 'start', display: 0 },
      { value: 'sstmId', text: 'System ID.', align: 'start', display: 0 },
      { value: 'mandant', text: 'Client No.', align: 'start', display: 0 },
      { value: 'ltxts', text: '', align: 'start', display: 0 },
      { value: 'msgv1', text: '', align: 'start', display: 0 },
      { value: 'msgv2', text: '', align: 'start', display: 0 },
      { value: 'msgv3', text: '', align: 'start', display: 0 },
      { value: 'msgv4', text: '', align: 'start', display: 0 },
    ],
  },
  G_ABAP_SYS_LOG: {
    fields: [
      { value: 'sapYmdhms', text: 'SAP Time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'type', text: 'Type', align: 'start', display: 1 },
      { value: 'nr', text: 'No.', align: 'start', display: 1 },
      { value: 'clnt', text: 'Client No.', align: 'start', display: 1 },
      { value: 'user', text: 'User ID', align: 'start', display: 1 },
      { value: 'terminal', text: 'Terminal', align: 'start', display: 1 },
      { value: 'tcode', text: 'T-Code', align: 'start', display: 1 },
      { value: 'package', text: 'Package', align: 'start', display: 1 },
      { value: 'program', text: 'Program', align: 'start', display: 1 },
      { value: 'priorityIcon', text: 'Priority', align: 'center', display: 1, type: 'icon' },
      { value: 'area', text: 'Group', align: 'center', display: 1 },
      { value: 'subid', text: 'Sub-id', align: 'start', display: 1 },
      { value: 'txt', text: 'Text', align: 'start', display: 1 },
      { value: 'svrYmdhms', text: 'Collect Time', align: 'start', display: 0 },
      { value: 'sstmId', text: 'System ID.', align: 'start', display: 0 },
      { value: 'fileNo', text: '', align: 'start', display: 0 },
      { value: 'pos', text: '', align: 'start', display: 0 },
    ],
  },
  // FINISH::Added.by.2023.06.21.KWShin.
  G_JAVA_LOG: {
    fields: [
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      { value: 'instId', text: 'Instance ID', align: 'start', display: 0 },
      { value: 'nodeId', text: 'Node ID', align: 'start', display: 0 },
      { value: 'svrYmdhms', text: 'Collected time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 0 },
      { value: 'sapYmdhms', text: 'SAP time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'seve', text: 'Severity', align: 'start', display: 1 },
      { value: 'cate', text: 'Category', align: 'start', display: 1 },
      { value: 'location', text: 'Location', align: 'start', display: 1 },
      { value: 'appl', text: 'Application Thread', align: 'start', display: 1 },
    ],
  },
  G_JAVA_MSG_CMCN: {
    fields: [
      // { value: 'svrYmdhms', text: 'Collected time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 0 },
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      { value: 'nodeId', text: 'Node ID', align: 'start', display: 1 },
      { value: 'svrYmdhms', text: 'Date & time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'msBytesSend', text: 'Send', align: 'end', converter: 'comma', display: 1 },
      { value: 'msBytesReceived', text: 'Received', align: 'end', converter: 'comma', display: 1 },
    ],
  },
  G_JAVA_ENQ_LOCK: {
    fields: [
      // { value: 'svrYmdhms', text: 'Collected time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 0 },
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      { value: 'nodeId', text: 'Node ID', align: 'start', display: 1 },
      { value: 'svrYmdhms', text: 'Date & time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'userName', text: 'User name', align: 'start', display: 1 },
      { value: 'ownerName', text: 'Owner name', align: 'start', display: 1 },
      { value: 'lockMode', text: 'Lock mode', align: 'start', display: 1 },
      { value: 'lockCount', text: 'Lock count', align: 'end', converter: 'comma', display: 1 },
      { value: 'lockName', text: 'Lock name', align: 'start', display: 1 },
      { value: 'lockArgment', text: 'Lock argument', align: 'start', display: 1 },
      { value: 'ns', text: 'Name space', align: 'start', display: 1 },
      { value: 'nsDesc', text: 'Name space desc.', align: 'start', display: 1 },
    ],
  },
  G_JAVA_REQ_QUEUE: {
    fields: [
      // { value: 'svrYmdhms', text: 'Collected time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 0 },
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      { value: 'nodeId', text: 'Node ID', align: 'start', display: 1 },
      { value: 'svrYmdhms', text: 'Date & time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'qtype', text: 'Queue type', align: 'start', display: 1 },
      { value: 'now', text: 'Wait', align: 'end', converter: 'comma', display: 1 },
      { value: 'high', text: 'High', align: 'end', converter: 'comma', display: 1 },
      { value: 'max', text: 'Max', align: 'end', converter: 'comma', display: 1 },
      { value: 'writes', text: 'Writes', align: 'end', converter: 'comma', display: 1 },
      { value: 'reads', text: 'Reads', align: 'end', converter: 'comma', display: 1 },
    ],
  },
  G_JAVA_RESP_TIME: {
    fields: [
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      { value: 'nodeId', text: 'Node ID', align: 'start', display: 1 },
      { value: 'svrYmdhms', text: 'Collected time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 0 },
      { value: 'starttime', text: 'Start time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 0 },
      { value: 'servicetype', text: 'Service Type', align: 'start', display: 1 },
      { value: 'actiontype', text: 'Action Type', align: 'start', display: 1 },
      { value: 'totStep', text: 'Total step', align: 'end', converter: 'comma', display: 1 },
      { value: 'totDbcalls', text: 'Total DB calls', align: 'end', converter: 'comma', display: 1 },
      { value: 'totResptime', text: 'Total response Time', align: 'end', converter: 'comma', display: 1 },
      { value: 'totCputime', text: 'Total CPU Time', align: 'end', converter: 'comma', display: 1 },
      { value: 'totDbtime', text: 'Total DB Time', align: 'end', converter: 'comma', display: 1 },
      { value: 'totResrctime', text: 'Total resource Time', align: 'end', converter: 'comma', display: 1 },
      { value: 'avgRespti', text: 'Average response Time', align: 'end', converter: 'comma', display: 1 },
      { value: 'avgCputi', text: 'Average CPU Time', align: 'end', converter: 'comma', display: 1 },
      { value: 'avgDbtime', text: 'Average DB Time', align: 'end', converter: 'comma', display: 1 },
      { value: 'owlviewData', text: 'owlView Data', align: 'start', display: 1 },
    ],
  },
  G_JAVA_OS_PRCS: {
    fields: [
      // { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      // { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      // { value: 'nodeId', text: 'Node ID', align: 'start', display: 1 },
      // { value: 'svrYmdhms', text: 'Collected time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 0 },
      // { value: 'procId', text: 'Process ID', align: 'start', display: 1 },
      // { value: 'username', text: 'Username', align: 'start', display: 1 },
      // { value: 'command', text: 'Command', align: 'start', display: 1 },
      // { value: 'cpuUtil', text: 'Cpu used rate', align: 'end', converter: ['concat', ' %'], display: 1 },
      // { value: 'cpuTime', text: 'Cpu time', align: 'end', display: 1 },
      // { value: 'memUtil', text: 'Mem used rate', align: 'end', converter: ['concat', ' %'], display: 1 },
      // { value: 'resSize', text: 'Res size', align: 'end', converter: 'comma', display: 1 },
      // { value: 'priority', text: 'Priority', align: 'end', converter: 'comma', display: 1 },
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      { value: 'nodeId', text: 'Node ID', align: 'start', display: 1 },
      { value: 'svrYmdhms', text: 'Date & time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'username', text: 'OS User', align: 'start', display: 1 },
      { value: 'command', text: 'Command', align: 'start', display: 1 },
      { value: 'cpuUtil', text: 'CPU Util.', align: 'end', converter: ['concat', ' %'], display: 1 },
      { value: 'cpuTime', text: 'CPU Time', align: 'end', display: 1 },
      { value: 'memUtil', text: 'MEM Util.', align: 'end', converter: ['concat', ' %'], display: 1 },
      { value: 'resSize', text: 'MEM Size (bytes)', align: 'end', converter: 'comma', display: 1 },
      { value: 'procId', text: 'PID', align: 'start', display: 1 },
      { value: 'priority', text: 'Priority', align: 'end', converter: 'comma', display: 1 },
    ],
  },
  G_JAVA_OS_CPU_WS: {
    fields: [
      // { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      // { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      // { value: 'nodeId', text: 'Node ID', align: 'start', display: 1 },
      // { value: 'svrYmdhms', text: 'Collected time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 0 },
      // { value: 'usr', text: 'Usr', align: 'end', converter: ['concat', ' %'], display: 1 },
      // { value: 'sys', text: 'Sys', align: 'end', converter: ['concat', ' %'], display: 1 },
      // { value: 'idle', text: 'Idle', align: 'end', converter: ['concat', ' %'], display: 1 },
      // { value: 'intSec', text: 'Int sec', align: 'end', converter: 'comma', display: 1 },
      // { value: 'syscSec', text: 'Sysc sec', align: 'end', converter: 'comma', display: 1 },
      // { value: 'csSec', text: 'Cs sec', align: 'end', converter: 'comma', display: 1 },
      // { value: 'load1Avg', text: 'Load1 sec', align: 'end', display: 1 },
      // { value: 'load5Avg', text: 'Load5 sec', align: 'end', display: 1 },
      // { value: 'load15Avg', text: 'Load15 sec', align: 'end', display: 1 },
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      { value: 'nodeId', text: 'Node ID', align: 'start', display: 1 },
      { value: 'svrYmdhms', text: 'Date & time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'usr', text: 'User total', align: 'end', converter: ['concat', ' %'], display: 1 },
      { value: 'sys', text: 'System total', align: 'end', converter: ['concat', ' %'], display: 1 },
      { value: 'idle', text: 'Idle total', align: 'end', converter: ['concat', ' %'], display: 1 },
      { value: 'syscSec', text: 'System calls', align: 'end', converter: 'comma', display: 1 },
      { value: 'intSec', text: 'Interrupts', align: 'end', converter: 'comma', display: 1 },
      { value: 'csSec', text: 'Context switches', align: 'end', converter: 'comma', display: 1 },
    ],
  },
  G_JAVA_OS_CPU: {
    fields: [
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      { value: 'nodeId', text: 'Node ID', align: 'start', display: 1 },
      { value: 'cpuUtil', text: 'Used Rate', align: 'end', converter: ['concat', ' %'], display: 1 },
    ],
  },
  G_JAVA_OS_MEM_WS: {
    fields: [
      // { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      // { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      // { value: 'nodeId', text: 'Node ID', align: 'start', display: 1 },
      // { value: 'svrYmdhms', text: 'Collected time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 0 },
      // { value: 'memSize', text: 'Memory size', align: 'end', converter: 'megabytes', display: 1 },
      // { value: 'memFree', text: 'Memory free', align: 'end', converter: 'megabytes', display: 1 },
      // { value: 'swapSize', text: 'Swap size', align: 'end', converter: 'megabytes', display: 1 },
      // { value: 'swapFree', text: 'Swap free', align: 'end', converter: 'megabytes', display: 1 },
      // { value: 'inPgSec', text: 'In pg sec', align: 'end', display: 1 },
      // { value: 'outPgSec', text: 'Out pg sec', align: 'end', display: 1 },
      // { value: 'inKbSec', text: 'in kb sec', align: 'end', display: 1 },
      // { value: 'outKbSec', text: 'Out kb sec', align: 'end', display: 1 },
      // { value: 'memUsedRate', text: 'Memory Used', align: 'end', converter: ['concat', ' %'], display: 1 },
      // { value: 'swapUsedRate', text: 'Swap Used', align: 'end', converter: ['concat', ' %'], display: 1 },
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      { value: 'nodeId', text: 'Node ID', align: 'start', display: 1 },
      { value: 'svrYmdhms', text: 'Date & time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'memSize', text: 'Total memory', align: 'end', converter: 'megabytes', display: 1 },
      { value: 'memFree', text: 'Free memory', align: 'end', converter: 'megabytes', display: 1 },
      { value: 'swapSize', text: 'Total swap', align: 'end', converter: 'megabytes', display: 1 },
      { value: 'swapFree', text: 'Free swap', align: 'end', converter: 'megabytes', display: 1 },
      { value: 'memUsedRate', text: 'Used rate (memory)', align: 'end', converter: ['concat', ' %'], display: 1 },
      { value: 'swapUsedRate', text: 'Used rate (swap)', align: 'end', converter: ['concat', ' %'], display: 1 },
      { value: 'inPgSec', text: 'Page in (sec)', align: 'end', display: 1 },
      { value: 'outPgSec', text: 'Page out (sec)', align: 'end', display: 1 },
      { value: 'inKbSec', text: 'Page in (KB/sec)', align: 'end', display: 1 },
      { value: 'outKbSec', text: 'Page out (KB/sec)', align: 'end', display: 1 },
    ],
  },
  G_JAVA_OS_MEM: {
    fields: [
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      { value: 'nodeId', text: 'Node ID', align: 'start', display: 1 },
      { value: 'memUtil', text: 'Used Rate', align: 'end', converter: ['concat', ' %'], display: 1 },
    ],
  },
  G_JAVA_OS_DISK_WS: {
    fields: [
      // { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      // { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      // { value: 'nodeId', text: 'Node ID', align: 'start', display: 1 },
      // { value: 'svrYmdhms', text: 'Collected time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 0 },
      // { value: 'diskname', text: 'Disk name', align: 'start', display: 1 },
      // { value: 'tps', text: 'Transfered', align: 'end', converter: 'kilobytes', display: 1 },
      // { value: 'util', text: 'Used Rate', align: 'end', converter: ['concat', ' %'], display: 1 },
      // { value: 'mrSec', text: 'Reads per sec', align: 'end', converter: 'megabytes', display: 1 },
      // { value: 'mwSec', text: 'Writes per sec', align: 'end', converter: 'megabytes', display: 1 },
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      { value: 'nodeId', text: 'Node ID', align: 'start', display: 1 },
      { value: 'svrYmdhms', text: 'Date & time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'diskname', text: 'Disk name', align: 'start', display: 1 },
      { value: 'tps', text: 'TPS', align: 'end', converter: 'kilobytes', display: 1 },
      { value: 'util', text: 'CPU Util.', align: 'end', converter: ['concat', ' %'], display: 1 },
      { value: 'mrSec', text: 'Reads (MB/sec)', align: 'end', converter: 'megabytes', display: 1 },
      { value: 'mwSec', text: 'Writes (MB/sec)', align: 'end', converter: 'megabytes', display: 1 },
    ],
  },
  G_JAVA_OS_DISK: {
    fields: [
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      { value: 'nodeId', text: 'Node ID', align: 'start', display: 1 },
      { value: 'diskUtil', text: 'Used Rate', align: 'end', converter: ['concat', ' %'], display: 1 },
    ],
  },
  G_JAVA_OS_NTWK_WS: {
    fields: [
      // { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      // { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      // { value: 'nodeId', text: 'Node ID', align: 'start', display: 1 },
      // { value: 'svrYmdhms', text: 'Collected time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 0 },
      // { value: 'lanname', text: 'LAN name', align: 'start', display: 1 },
      // { value: 'rxBytes', text: 'Bytes in per interval', converter: 'bytes', display: 1 },
      // { value: 'txBytes', text: 'Bytes out per interval', converter: 'bytes', display: 1 },
      // { value: 'rxPackets', text: 'Packets in per interval', align: 'end', converter: 'comma', display: 1 },
      // { value: 'txPackets', text: 'Packets out per interval', align: 'end', converter: 'comma', display: 1 },
      // { value: 'rxErrors', text: 'Errors in per interval', align: 'end', converter: 'comma', display: 1 },
      // { value: 'txErrors', text: 'Errors out per interval', align: 'end', converter: 'comma', display: 1 },
      // { value: 'rxDropped', text: 'Dropped in per interval', align: 'end', converter: 'comma', display: 1 },
      // { value: 'txDropped', text: 'Dropped out per interval', align: 'end', converter: 'comma', display: 1 },
      // { value: 'mcast', text: 'mcast', align: 'end', converter: 'comma', display: 1 },
      // { value: 'carrier', text: 'carrier', align: 'end', converter: 'comma', display: 1 },
      // { value: 'collsns', text: 'collsns', align: 'end', converter: 'comma', display: 1 },
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      { value: 'nodeId', text: 'Node ID', align: 'start', display: 1 },
      { value: 'svrYmdhms', text: 'Date & time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'lanname', text: 'LAN name', align: 'start', display: 1 },
      { value: 'rxPackets', text: 'Packets in', align: 'end', converter: 'comma', display: 1 },
      { value: 'txPackets', text: 'Packets out', align: 'end', converter: 'comma', display: 1 },
      { value: 'rxBytes', text: 'Bytes in', converter: 'bytes', display: 1 },
      { value: 'txBytes', text: 'Bytes out', converter: 'bytes', display: 1 },
      { value: 'rxErrors', text: 'Errors in', align: 'end', converter: 'comma', display: 1 },
      { value: 'txErrors', text: 'Errors out', align: 'end', converter: 'comma', display: 1 },
      { value: 'collsns', text: 'Collisions', align: 'end', converter: 'comma', display: 1 },
    ],
  },
  G_JAVA_JDBC_CONN: {
    fields: [
      // { value: 'svrYmdhms', text: 'Collected time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 0 },
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      { value: 'nodeId', text: 'Node ID', align: 'start', display: 1 },
      { value: 'svrYmdhms', text: 'Date & time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'dsName', text: 'Datasource name', align: 'start', display: 1 },
      { value: 'maxSize', text: 'Max size', align: 'end', converter: 'comma', display: 1 },
      { value: 'usedSize', text: 'Used size', align: 'end', converter: 'comma', display: 1 },
    ],
  },
  G_JAVA_TRXN: {
    fields: [
      // { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      // { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      // { value: 'nodeId', text: 'Node ID', align: 'start', display: 1 },
      // { value: 'svrYmdhms', text: 'Collected time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 0 },
      // { value: 'openTransCount', text: 'Open Transaction', align: 'end', converter: 'comma', display: 1 },
      // { value: 'committedCount', text: 'Committed', align: 'end', converter: 'comma', display: 1 },
      // { value: 'rolledbackCount', text: 'Rolledback', align: 'end', converter: 'comma', display: 1 },
      // { value: 'suspendedCount', text: 'Suspended', align: 'end', converter: 'comma', display: 1 },
      // { value: 'timedoutCount', text: 'Timedout', align: 'end', converter: 'comma', display: 1 },
      // { value: 'successRate', text: 'Success rate', align: 'end', converter: ['concat', ' %'], display: 1 },
      // { value: 'totalCommittedCount', text: 'Total committed', align: 'end', converter: 'comma', display: 1 },
      // { value: 'totalRolledbackCount', text: 'Total rolledback', align: 'end', converter: 'comma', display: 1 },
      // { value: 'totalSuspendedCount', text: 'Total suspended', align: 'end', converter: 'comma', display: 1 },
      // { value: 'totalTimedoutCount', text: 'Total timedout', align: 'end', converter: 'comma', display: 1 },
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      { value: 'nodeId', text: 'Node ID', align: 'start', display: 1 },
      { value: 'svrYmdhms', text: 'Date & time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'openTransCount', text: 'Open', align: 'end', converter: 'comma', display: 1 },
      { value: 'committedCount', text: 'Committed', align: 'end', converter: 'comma', display: 1 },
      { value: 'rolledbackCount', text: 'Rolledback', align: 'end', converter: 'comma', display: 1 },
      { value: 'suspendedCount', text: 'Suspended', align: 'end', converter: 'comma', display: 1 },
      { value: 'timedoutCount', text: 'Timedout', align: 'end', converter: 'comma', display: 1 },
      { value: 'successRate', text: 'Success rate', align: 'end', converter: ['concat', ' %'], display: 1 },
    ],
  },
  G_JAVA_DB_LOCK: {
    fields: [
      // { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      // { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      // { value: 'nodeId', text: 'Node ID', align: 'start', display: 1 },
      // { value: 'svrYmdhms', text: 'Collected time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 0 },
      // { value: 'pathsOfBlockingLocks', text: 'Paths of blocking locks', align: 'end', converter: 'comma', display: 1 },
      // { value: 'accessMode', text: 'Access mode', align: 'end', converter: 'comma', display: 1 },
      // { value: 'lockOwnerTransId', text: 'Lock owner trans id', align: 'start', display: 1 },
      // { value: 'blockingTime', text: 'Blocking time', align: 'end', converter: 'comma', display: 1 },
      // { value: 'waiters', text: 'Waiters', align: 'end', converter: 'comma', display: 1 },
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      { value: 'nodeId', text: 'Node ID', align: 'start', display: 1 },
      { value: 'svrYmdhms', text: 'Date & time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'pathsOfBlockingLocks', text: 'Paths of blocking locks', align: 'end', converter: 'comma', display: 1 },
      { value: 'accessMode', text: 'Access mode', align: 'end', converter: 'comma', display: 1 },
      { value: 'lockOwnerTransId', text: 'Lock owner', align: 'start', display: 1 },
      { value: 'blockingTime', text: 'Blocking time', align: 'end', converter: 'comma', display: 1 },
      { value: 'waiters', text: 'Waiters', align: 'end', converter: 'comma', display: 1 },
    ],
  },
  G_JAVA_HTTP_SESS: {
    fields: [
      // { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      // { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      // { value: 'nodeId', text: 'Node ID', align: 'start', display: 1 },
      // { value: 'svrYmdhms', text: 'Collected time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 0 },
      // { value: 'username', text: 'Username', align: 'start', display: 1 },
      // { value: 'sessionId', text: 'Session ID', align: 'start', display: 1 },
      // { value: 'created', text: 'Created', align: 'start', display: 1 },
      // { value: 'expire', text: 'Expire', align: 'start', display: 1 },
      // { value: 'lastAccessed', text: 'Last accessed', align: 'start', display: 1 },
      // { value: 'application', text: 'Application', align: 'start', display: 1 },
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      { value: 'nodeId', text: 'Node ID', align: 'start', display: 1 },
      { value: 'svrYmdhms', text: 'Date & time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'username', text: 'User name', align: 'start', display: 1 },
      { value: 'created', text: 'Created', align: 'start', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'expire', text: 'Expire', align: 'start', display: 1 },
      { value: 'lastAccessed', text: 'Last accessed', align: 'start', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'application', text: 'Application', align: 'start', display: 1 },
      { value: 'sessionId', text: 'Session ID', align: 'start', display: 1 },
    ],
  },
  G_JAVA_SSTM_THRD: {
    fields: [
      // { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      // { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      // { value: 'nodeId', text: 'Node ID', align: 'start', display: 1 },
      // { value: 'svrYmdhms', text: 'Collected time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 0 },
      // { value: 'waitingTasksCount', text: 'Waiting tasks count', align: 'end', converter: 'comma', display: 1 },
      // { value: 'waitingTasksUsageRate', text: 'Waiting tasks usage rate', align: 'end', converter: ['concat', ' %'], display: 1 },
      // { value: 'waitingTasksQueueOverflow', text: 'Waiting tasks queue overflow', align: 'end', converter: 'comma', display: 1 },
      // { value: 'maxWaitingTasksQueueSize', text: 'Max waiting tasks queue size', align: 'end', converter: 'comma', display: 1 },
      // { value: 'initialThreadCount', text: 'Initial thread count', align: 'end', converter: 'comma', display: 1 },
      // { value: 'minThreadCount', text: 'Min thread count', align: 'end', converter: 'comma', display: 1 },
      // { value: 'maxThreadCount', text: 'Max thread count', align: 'end', converter: 'comma', display: 1 },
      // { value: 'activeThreadsCount', text: 'Active threads', align: 'end', converter: 'comma', display: 1 },
      // { value: 'currentThreadCount', text: 'Current thread', align: 'end', converter: 'comma', display: 1 },
      // { value: 'threadPoolCapacityRate', text: 'Thread pool capacity', align: 'end', converter: ['concat', ' %'], display: 1 },
      // { value: 'threadPoolUsageRate', text: 'Thread pool usage', align: 'end', converter: ['concat', ' %'], display: 1 },
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      { value: 'nodeId', text: 'Node ID', align: 'start', display: 1 },
      { value: 'svrYmdhms', text: 'Date & time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'activeThreadsCount', text: 'Active threads', align: 'end', converter: 'comma', display: 1 },
      { value: 'waitingTasksCount', text: 'Waiting tasks', align: 'end', converter: 'comma', display: 1 },
      { value: 'currentThreadCount', text: 'Current threads', align: 'end', converter: 'comma', display: 1 },
      { value: 'threadPoolCapacityRate', text: 'Thread pool capacity', align: 'end', converter: ['concat', ' %'], display: 1 },
      { value: 'threadPoolUsageRate', text: 'Thread pool usage', align: 'end', converter: ['concat', ' %'], display: 1 },
      { value: 'initialThreadCount', text: 'Initial threads', align: 'end', converter: 'comma', display: 1 },
      { value: 'minThreadCount', text: 'Min threads', align: 'end', converter: 'comma', display: 1 },
      { value: 'maxThreadCount', text: 'Max threads', align: 'end', converter: 'comma', display: 1 },
    ],
  },
  G_JAVA_APPL_THRD: {
    fields: [
      // { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      // { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      // { value: 'nodeId', text: 'Node ID', align: 'start', display: 1 },
      // { value: 'svrYmdhms', text: 'Collected time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 0 },
      // { value: 'waitingTasksCount', text: 'Waiting tasks count', align: 'end', converter: 'comma', display: 1 },
      // { value: 'waitingTasksUsageRate', text: 'Waiting tasks usage rate', align: 'end', converter: ['concat', ' %'], display: 1 },
      // { value: 'waitingTasksQueueOverflow', text: 'Waiting tasks queue overflow', align: 'end', converter: 'comma', display: 1 },
      // { value: 'maxWaitingTasksQueueSize', text: 'Max waiting tasks queue size', align: 'end', converter: 'comma', display: 1 },
      // { value: 'initialThreadCount', text: 'Initial thread count', align: 'end', converter: 'comma', display: 1 },
      // { value: 'minThreadCount', text: 'Min thread count', align: 'end', converter: 'comma', display: 1 },
      // { value: 'maxThreadCount', text: 'Max thread count', align: 'end', converter: 'comma', display: 1 },
      // { value: 'activeThreadsCount', text: 'Active threads', align: 'end', converter: 'comma', display: 1 },
      // { value: 'currentThreadCount', text: 'Current thread', align: 'end', converter: 'comma', display: 1 },
      // { value: 'threadPoolCapacityRate', text: 'Thread pool capacity', align: 'end', converter: ['concat', ' %'], display: 1 },
      // { value: 'threadPoolUsageRate', text: 'Thread pool usage', align: 'end', converter: ['concat', ' %'], display: 1 },
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      { value: 'nodeId', text: 'Node ID', align: 'start', display: 1 },
      { value: 'svrYmdhms', text: 'Date & time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'activeThreadsCount', text: 'Active threads', align: 'end', converter: 'comma', display: 1 },
      { value: 'waitingTasksCount', text: 'Waiting tasks', align: 'end', converter: 'comma', display: 1 },
      { value: 'currentThreadCount', text: 'Current threads', align: 'end', converter: 'comma', display: 1 },
      { value: 'threadPoolCapacityRate', text: 'Thread pool capacity', align: 'end', converter: ['concat', ' %'], display: 1 },
      { value: 'threadPoolUsageRate', text: 'Thread pool usage', align: 'end', converter: ['concat', ' %'], display: 1 },
      { value: 'initialThreadCount', text: 'Initial threads', align: 'end', converter: 'comma', display: 1 },
      { value: 'minThreadCount', text: 'Min threads', align: 'end', converter: 'comma', display: 1 },
      { value: 'maxThreadCount', text: 'Max threads', align: 'end', converter: 'comma', display: 1 },
    ],
  },
  G_JAVA_HTTP_PRVDR: {
    fields: [
      // { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      // { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      // { value: 'nodeId', text: 'Node ID', align: 'start', display: 1 },
      // { value: 'svrYmdhms', text: 'Collected time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 0 },
      // { value: 'totalAvgResponseTime', text: 'Total Average response time', align: 'end', converter: 'comma', display: 1 },
      // { value: 'totalRequestCount', text: 'Total Request count', align: 'end', converter: 'comma', display: 1 },
      // { value: 'totalResponseCount', text: 'Total Response count', align: 'end', converter: 'comma', display: 1 },
      // { value: 'requestCount', text: 'Request count', align: 'end', converter: 'comma', display: 1 },
      // { value: 'responseCount', text: 'Response count', align: 'end', converter: 'comma', display: 1 },
      // { value: 'avgResponseTime', text: 'Average response time', align: 'end', converter: 'comma', display: 1 },
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      { value: 'nodeId', text: 'Node ID', align: 'start', display: 1 },
      { value: 'svrYmdhms', text: 'Date & time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'requestCount', text: 'Requests', align: 'end', converter: 'comma', display: 1 },
      { value: 'responseCount', text: 'Responses', align: 'end', converter: 'comma', display: 1 },
      { value: 'totalResponseTime', text: 'Total RS Time', align: 'end', converter: 'comma', display: 1 },
      { value: 'avgResponseTime', text: 'Avg. RS Time', align: 'end', converter: 'comma', display: 1 },
      { value: 'totalRequestCount', text: 'Total requests', align: 'end', converter: 'comma', display: 1 },
      { value: 'totalResponseCount', text: 'Total responses', align: 'end', converter: 'comma', display: 1 },
    ],
  },
  G_JAVA_JSP: {
    fields: [
      // { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      // { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      // { value: 'nodeId', text: 'Node ID', align: 'start', display: 1 },
      // { value: 'svrYmdhms', text: 'Collected time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 0 },
      // { value: 'totalRequestCount', text: 'Total Request Count', align: 'end', converter: 'comma', display: 1 },
      // { value: 'totalResponseCount', text: 'Total Response Count', align: 'end', converter: 'comma', display: 1 },
      // { value: 'currentHttpSessions', text: 'Current Http Sessions', align: 'end', converter: 'comma', display: 1 },
      // { value: 'currentSecuritySessions', text: 'Current Security Sessions', align: 'end', converter: 'comma', display: 1 },
      // { value: 'requestCount', text: 'request Count', align: 'end', converter: 'comma', display: 1 },
      // { value: 'responseCount', text: 'response Count', align: 'end', converter: 'comma', display: 1 },
      // { value: 'httpSessInvalidByApp', text: 'Http Session Invalid By App', align: 'end', converter: 'comma', display: 1 },
      // { value: 'securitySessInvalidByApp', text: 'Security Session Invalid By App', align: 'end', converter: 'comma', display: 1 },
      // { value: 'timedOutHttpSess', text: 'Timed out HTTP sessions', align: 'end', converter: 'comma', display: 1 },
      // { value: 'timedOutSecuritySess', text: 'Timed out HTTPS sessions', align: 'end', converter: 'comma', display: 1 },
      // { value: 'avgResponseTime', text: 'Average response time', align: 'end', converter: 'comma', display: 1 },
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      { value: 'nodeId', text: 'Node ID', align: 'start', display: 1 },
      { value: 'svrYmdhms', text: 'Date & time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'requestCount', text: 'Requests', align: 'end', converter: 'comma', display: 1 },
      { value: 'responseCount', text: 'Responses', align: 'end', converter: 'comma', display: 1 },
      { value: 'totalResponseTime', text: 'Total RS Time', align: 'end', converter: 'comma', display: 1 },
      { value: 'avgResponseTime', text: 'Avg. RS Time', align: 'end', converter: 'comma', display: 1 },
      { value: 'totalRequestCount', text: 'Total Requests', align: 'end', converter: 'comma', display: 1 },
      { value: 'totalResponseCount', text: 'Total Responses', align: 'end', converter: 'comma', display: 1 },
    ],
  },
  G_JAVA_P4: {
    fields: [
      // { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      // { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      // { value: 'nodeId', text: 'Node ID', align: 'start', display: 1 },
      // { value: 'svrYmdhms', text: 'Collected time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 0 },
      // { value: 'totalRequestCount', text: 'Total Request count', align: 'end', converter: 'comma', display: 1 },
      // { value: 'totalErrorRequestCount', text: 'Total Error Request count', align: 'end', converter: 'comma', display: 1 },
      // { value: 'totalExportedRemoteObjectsCount', text: 'Total Exported Remote Objects Count', align: 'end', converter: 'comma', display: 1 },
      // { value: 'requestCount', text: 'Request count', align: 'end', converter: 'comma', display: 1 },
      // { value: 'errorRequestCount', text: 'Error Request count', converter: 'comma', display: 1 },
      // { value: 'exportedRemoteObjectsCount', text: 'Exported Remote Objects Count', align: 'end', converter: 'comma', display: 1 },
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      { value: 'nodeId', text: 'Node ID', align: 'start', display: 1 },
      { value: 'svrYmdhms', text: 'Date & time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'requestCount', text: 'Requests', align: 'end', converter: 'comma', display: 1 },
      { value: 'errorRequestCount', text: 'Error requests', converter: 'comma', display: 1 },
      { value: 'exportedRemoteObjectsCount', text: 'Exported remote objects', align: 'end', converter: 'comma', display: 1 },
      { value: 'totalRequestCount', text: 'Total Requests', align: 'end', converter: 'comma', display: 1 },
      { value: 'totalErrorRequestCount', text: 'Total error requests', align: 'end', converter: 'comma', display: 1 },
      { value: 'totalExportedRemoteObjectsCount', text: 'Total exported remote objects', align: 'end', converter: 'comma', display: 1 },
    ],
  },
  G_JAVA_SVC_STAT: {
    fields: [
      // { value: 'svrYmdhms', text: 'Collected time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 0 },
      { value: 'sstmId', text: 'System ID', align: 'start', display: 1 },
      { value: 'instId', text: 'Instance ID', align: 'start', display: 1 },
      { value: 'nodeId', text: 'Node ID', align: 'start', display: 1 },
      { value: 'svrYmdhms', text: 'Date & time', align: 'center', converter: ['format', 'yyyy-MM-dd HH:mm:ss'], display: 1 },
      { value: 'serviceName', text: 'Name', align: 'start', display: 1 },
      { value: 'serviceType', text: 'Type', align: 'start', display: 1 },
      { value: 'stat', text: 'Status', align: 'start', display: 1 },
    ],
  },
};
